<template>
  <div id="print-page">
    <div class="h-print mb-1">
      <b
        >Please ensure that the margin settings of your print to PDF is set to
        "None"</b
      >
      <el-button
        v-if="showFinalizeButton"
        class="ml-2"
        size="mini"
        :loading="isProcessing"
        type="primary"
        @click="sendPdf"
      >
        {{ finalizeButtonLabel }}
      </el-button>
    </div>
    <div ref="printContent" class="print-page-wrapper">
      <div v-if="displayHeader" class="page-header">
        <div class="header-logo">
          <img src="/images/x-total.jpg" alt="logo" />
        </div>
        <div class="header-text">
          <img
            src="/images/total-expertise-arabic-header.png"
            alt="arabic header"
          />
          <h3>TOTAL Expertise For Trading &amp; Industrials Co. Ltd.</h3>
          <!-- <span v-if="displaySubheader" class="sub-header"
            >GCAA Approval No.: <b>UAE.145.0021</b></span
          > -->
        </div>
      </div>
      <div class="page-content">
        <table id="page-layout">
          <thead>
            <tr>
              <td>
                <div class="header-space">&nbsp;</div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content"><slot></slot></div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div class="footer-space">&nbsp;</div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="page-footer">
        <div class="footer-content text-center">
          <div class="custom-footer">
            <slot name="customFooter"></slot>
          </div>
          <!-- this is footer -->
          <!-- <slot name="extrafooter"></slot> -->
          <template v-if="displayExtraFooter">
            <div id="extrafooter" class="text-left">
              <a
                href="#"
                @click.prevent="viewEditDialog = true"
                title="Click here to edit footer"
              >
                <span class="mr-2">{{ footer.description }}</span>
                <span class="ui-icon el-icon-edit-outline"></span>
              </a>
            </div>
            <el-dialog
              title="Edit footer"
              :visible.sync="viewEditDialog"
              width="50%"
              :close-on-click-modal="false"
              @open="loadFooters"
              v-loading="isLoading"
            >
              <el-form ref="footerForm" :model="footerEdit" :rules="rules">
                <el-form-item label="Footer options" v-show="!viewEdit">
                  <el-select v-model="footer.id">
                    <el-option
                      v-for="item in footers"
                      :key="item.id"
                      :value="item.id"
                      :label="item.description"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="Footer Description"
                  v-show="viewEdit"
                  prop="description"
                >
                  <el-input
                    v-model="footerEdit.description"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="d-flex justify-content-flex-end">
                <el-button
                  size="small"
                  type="info"
                  v-show="!viewEdit"
                  v-if="false"
                  >New</el-button
                >
                <el-button
                  size="small"
                  @click="editFooter"
                  type="info"
                  v-show="!viewEdit"
                  >Edit Selected</el-button
                >
                <el-button
                  size="small"
                  type="primary"
                  v-show="viewEdit"
                  @click="updateFooter"
                  >Save</el-button
                >
                <el-button
                  size="small"
                  type="primary"
                  v-show="!viewEdit"
                  @click="useFooter"
                  >Use Selected</el-button
                >
                <el-button size="small" @click="viewEditDialog = false"
                  >Cancel</el-button
                >
              </div>
            </el-dialog>
          </template>
          <template v-if="displayFooter">
            <span class="footer-divider"></span>
            <div class="d-flex justify-content-space-around">
              <div>
                <span
                  >Mussafah Ind’l. Area, ICAD 3 – M/41, Warehouse B1501-P.O. Box
                  91219</span
                >
                <div class="d-flex justify-content-space-between">
                  <span>Tel.:+971 2 5509485,</span>
                  <span>Fax: +971 2 5509484,</span>
                  <span>Abu Dhabi, U.A.E.</span>
                </div>
              </div>
              <img src="/images/total-expertise-arabic-footer.png" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
export default {
  props: {
    viewFooter: {
      type: Boolean,
      default: true
    },
    viewSubheader: {
      type: Boolean,
      default: true
    },
    viewHeader: {
      type: Boolean,
      default: true
    },
    viewExtraFooter: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ""
    },
    finalizeUrl: {
      type: String,
      default: ""
    },
    finalizePayload: {
      type: Object,
      default: () => ({})
    },
    finalizeButtonLabel: {
      type: String,
      default: "Send PDF"
    },
    showFinalizeButton: {
      type: Boolean,
      default: false
    },
    downloadOnly: {
      type: Boolean,
      default: false
    },
    downloadFileName: {
      type: String,
      default: "document.pdf"
    },
    fitSinglePage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      footers: [],
      footer: {},
      footerEdit: {},
      viewEditDialog: false,
      viewEdit: false,
      rules: {
        description: [{ required: true }]
      },
      isLoading: false,
      isProcessing: false
    };
  },
  computed: {
    displayFooter() {
      if (this.viewFooter === false) return false;
      return true;
    },
    displayHeader() {
      if (this.viewHeader === false) return false;
      return true;
    },
    displaySubheader() {
      if (this.viewSubheader === false) return false;
      return true;
    },
    displayExtraFooter() {
      if (this.viewExtraFooter === true) return true;
      return false;
    }
  },
  mounted() {
    this.$store.dispatch("ui/togglePrintView");
    this.loadFooters();
  },
  methods: {
    async sendPdf() {
      const printContainer = this.$refs.printContent;
      if (!printContainer) {
        this.$message &&
          this.$message.error("Unable to locate the print content.");
        return;
      }
      let recipientEmail = "";
      if (!this.downloadOnly) {
        if (!this.finalizeUrl) {
          this.$message &&
            this.$message.error(
              "No endpoint configured for sending the PDF. Please provide `finalizeUrl`."
            );
          return;
        }
        try {
          const promptResult = await this.$prompt(
            "Provide the recipient email.",
            "Recipient Email",
            {
              inputValue: this.finalizePayload.email || "",
              confirmButtonText: "Confirm",
              cancelButtonText: "Cancel",
              inputPattern: /.+@.+\..+/,
              inputErrorMessage: "Please enter a valid email address."
            }
          );
          recipientEmail = promptResult.value;
        } catch (err) {
          return;
        }
        try {
          await this.$confirm(
            "Are you sure want send to this email ?",
            recipientEmail,
            {
              confirmButtonText: "Yes",
              cancelButtonText: "No",
              type: "warning"
            }
          );
        } catch (err) {
          return;
        }
      }
      this.isProcessing = true;
      try {
        await this.$nextTick();
        const canvas = await html2canvas(printContainer, {
          useCORS: true,
          allowTaint: true,
          scale: 2,
          windowWidth: printContainer.scrollWidth,
          windowHeight: printContainer.scrollHeight
        });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const imgProps = pdf.getImageProperties(imgData);
        if (this.fitSinglePage) {
          const ratio = Math.min(
            pageWidth / imgProps.width,
            pageHeight / imgProps.height
          );
          const renderWidth = imgProps.width * ratio;
          const renderHeight = imgProps.height * ratio;
          const offsetX = (pageWidth - renderWidth) / 2;
          pdf.addImage(imgData, "PNG", offsetX, 0, renderWidth, renderHeight);
        } else {
          const imgHeight = (imgProps.height * pageWidth) / imgProps.width;
          let heightLeft = imgHeight;
          let position = 0;

          pdf.addImage(imgData, "PNG", 0, position, pageWidth, imgHeight);
          heightLeft -= pageHeight;

          while (heightLeft > 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, "PNG", 0, position, pageWidth, imgHeight);
            heightLeft -= pageHeight;
          }
        }

        if (this.downloadOnly) {
          const filename = this.downloadFileName || "document.pdf";
          pdf.save(filename);
          this.$message &&
            this.$message.success("PDF downloaded successfully.");
          return;
        }

        const dataUri = pdf.output("datauristring");
        const base64 = dataUri.split(",")[1];
        const payload = {
          ...this.finalizePayload,
          email: recipientEmail,
          form1_pdf: base64
        };
        const response = await api.post(this.finalizeUrl, payload, "json");
        this.$message &&
          this.$message.success(
            "PDF generated and submitted successfully."
          );
        return response;
      } catch (err) {
        console.error("Failed to generate or submit PDF", err);
        this.$message &&
          this.$message.error("Unable to submit PDF. Please try again.");
      } finally {
        this.isProcessing = false;
      }
    },
    loadFooters() {
      this.isLoading = true;
      api.get(`/api/v1/dashboard/get_footer/`).then(resp => {
        if (resp && resp.status == 200) {
          if (
            "data" in resp.data &&
            "msg" in resp.data.data &&
            resp.data.data.msg.length > 0
          ) {
            this.footers = resp.data.data.msg;
            // this.footers.push({ id: 99, description: "test" });
            this.footer = { ...this.footers[0] };
          }
        }
        this.isLoading = false;
      });
    },
    updateFooter() {
      this.$refs.footerForm.validate(valid => {
        if (!valid) return false;

        this.isLoading = true;
        api
          .put(
            `/api/v1/dashboard/update_footer/${this.footerEdit.id}/`,
            this.footerEdit
          )
          .then(resp => {
            if (resp && resp.status == 200) {
              let data = resp.data.data.msg;
              if (data.code == 200) {
                this.viewEdit = false;
                this.viewEditDialog = false;
                this.footer = { ...this.footerEdit };
              }
            }
            this.isLoading = false;
          });
      });
    },
    editFooter() {
      this.viewEdit = true;
      this.footerEdit = { ...this.footer };
    },
    useFooter() {
      let footer = this.footers.find(o => {
        return o.id == this.footer.id;
      });
      if (footer) {
        this.footer = { ...footer };
        this.viewEditDialog = false;
      }
    }
  }
};
</script>
<style lang="scss">
.footer-divider {
  display: block;
  border-bottom: 1px solid #333;
  border-top: 1px solid #333;
  padding: 2px;
  margin-bottom: 8px;
  margin-top: 8px;
}
.header-text .sub-header {
  width: 100%;
  text-align: center;
  display: block;
  font-size: 10px;
}
#print-page {
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #dadce0;
  padding-top: 30px;
  padding-bottom: 30px;
  font-size: 16px;
  font-family: "Calibri", sans-serif;
  .print-page-wrapper {
    width: 210mm;
    min-height: 296mm;
    padding: 8mm 14mm;
    background: #fff;
  }
  .page-header {
    display: flex;
    font-family: "Times-New-Roman", serif;
    justify-content: center;
    .header-logo {
      width: 60px;
      margin-right: 15px;
      img {
        width: 100%;
      }
    }
    .header-text {
      margin-top: -5px;
      h3 {
        font-size: 24px;
        margin-top: -10px;
        border-bottom: 2px solid #4343a1;
      }
    }
  }
  .footer-content {
    margin-top: 30px;
    font-size: 12px;
  }
  .page-content {
    #page-layout {
      width: 100%;
      // margin-top: calc(120px - 72px);
      > thead {
        display: none;
      }
      > tfoot {
        display: none;
      }
    }
  }
}

#extrafooter {
  color: #333;
  a {
    color: #333;
  }
}

.custom-footer {
  font-size: 14px;
}

@media screen {
  .print-page-wrapper {
    display: flex;
    flex-direction: column;
    .page-content {
      flex-grow: 1;
    }
  }
  .page-footer {
    // position: absolute;
    // bottom: 50px;
    // width: 687px;
  }
}

@media print {
  body,
  #app {
    height: 100%;
    .h-print {
      display: none;
    }
  }
  #print-page {
    padding-top: 0;
    padding-bottom: 0;
    .page-header {
      width: 100%;
      position: fixed;
      // top: 10px;
      left: 0;
      padding-top: 8mm;
      overflow: hidden;
    }
    .page-footer {
      width: 100%;
      position: fixed;
      // bottom: 10px;
      left: 0;
      overflow: hidden;
      bottom: 5mm;
      .footer-content {
        margin-top: 0;
      }
      .footer-divider {
        width: 90%;
        margin-left: 5%;
      }
    }
    .print-page-wrapper {
      padding-top: 0;
      padding-bottom: 0;
      width: 100% !important;
    }
    .header-space {
      height: 120px;
    }
    .footer-space {
      // background-color: red;
      height: 80px !important;
      width: 100%;
    }
    #page-layout {
      > thead {
        display: table-header-group !important;
      }
      > tfoot {
        display: table-footer-group !important;
      }
    }
  }
  #extrafooter {
    margin-left: 14mm;
    .ui-icon {
      display: none;
    }
  }
  .custom-footer {
    margin-left: 14mm;
  }
}

@page {
  size: A4;
  margin: 0;
}

table {
  page-break-inside: auto;
}
tr {
  page-break-inside: avoid;
  page-break-after: auto;
}
</style>
